/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatManagementEditStatusResponse } from './ChatManagementEditStatusResponse';

export type ChatManagementEditStatusResponseApiRespoonse = {
    data?: ChatManagementEditStatusResponse;
    status?: ChatManagementEditStatusResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ChatManagementEditStatusResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

